export enum EC2Events {
  INIT_SYNC = 'initSync',
  FINISHED_SYNC = 'finishedSync',
}
